import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-management" }
const _hoisted_2 = { class: "actions-bar" }

import { ref, computed, onMounted, onUnmounted } from "vue";
import { useQuery, useMutation, useQueryClient } from "@tanstack/vue-query";
import UserTable from "./components/UserTable.vue";
import UserFormModal from "./components/UserFormModal.vue";
import { useUsersQuery, useRolesQuery, useRefreshFromLdapMutation } from "./api.js";


export default {
  __name: 'UserManagement',
  setup(__props) {

const { data: usersData, isPending, isError, error } = useQuery(useUsersQuery());
const users = computed(() => usersData.value || []);

const { data: rolesData } = useQuery(useRolesQuery());
const roles = computed(() => rolesData.value || []);

const queryClient = useQueryClient();
const refreshMutation = useMutation(useRefreshFromLdapMutation(queryClient));
const refreshingId = ref(null);

const isRefreshing = (id) => refreshingId.value === id;

const handleRefresh = (id) => {
	refreshingId.value = id;
	refreshMutation.mutate(id, {
		onSettled: () => {
			refreshingId.value = null;
		},
		onError: (err) => window.alert(err.message || "Die Aktualisierung von LDAP ist fehlgeschlagen."),
	});
};

const modal = ref({ mode: null, user: null });

const openModal = (mode, user = null) => {
	modal.value = { mode, user };
};

const closeModal = () => {
	modal.value = { mode: null, user: null };
};

const userTableRef = ref(null);

const handleGlobalKeydown = (event) => {
	if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "f" && !modal.value.mode) {
		event.preventDefault();
		userTableRef.value?.focusSearch();
	}
};

onMounted(() => window.addEventListener("keydown", handleGlobalKeydown));
onUnmounted(() => window.removeEventListener("keydown", handleGlobalKeydown));

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success me-2",
          "data-testid": "create-local-account",
          onClick: _cache[0] || (_cache[0] = $event => (openModal('create-local')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fas fa-plus" }, null, -1 /* CACHED */),
          _createTextVNode(" Lokalen Account anlegen ", -1 /* CACHED */)
        ]))]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-testid": "import-wwu-account",
          onClick: _cache[1] || (_cache[1] = $event => (openModal('create-wwu')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fas fa-plus" }, null, -1 /* CACHED */),
          _createTextVNode(" Uni-Account importieren ", -1 /* CACHED */)
        ]))])
      ])
    ]),
    _createVNode(UserTable, {
      ref_key: "userTableRef",
      ref: userTableRef,
      users: users.value,
      roles: roles.value,
      loading: _unref(isPending),
      error: _unref(isError) ? (_unref(error)?.message || String(_unref(error))) : '',
      "is-refreshing": isRefreshing,
      onRefresh: handleRefresh,
      onEdit: _cache[2] || (_cache[2] = (user) => openModal('edit', user)),
      onDeleted: () => {}
    }, null, 8 /* PROPS */, ["users", "roles", "loading", "error"]),
    (modal.value.mode)
      ? (_openBlock(), _createBlock(UserFormModal, {
          key: `${modal.value.mode}-${modal.value.user?.id ?? 'new'}`,
          show: true,
          mode: modal.value.mode,
          user: modal.value.user,
          roles: roles.value,
          onClose: closeModal,
          onSaved: closeModal
        }, null, 8 /* PROPS */, ["mode", "user", "roles"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}